<template>
    <div class="row d-flex justify-content-center">
        <div class="col-lg-8 col-md-12">
            <user-edit-form
                :user="user"
                :customers="customers"
                :designers="designers"
                :user-roles="userRoles"
                :user-added="userAdded"
                :password-min-length="passwordMinLength"
                @searchDesigners="$emit('searchDesigners', $event)"
                @searchCustomers="$emit('searchCustomers', $event)"
                @updateUser="$emit('updateUser', $event)"
                @createAdditionalUser="$emit('createAdditionalUser', $event)"
            />
        </div>
        <div class="col-lg-4 col-md-12">
            <user-profile-card :user="user" />
        </div>
    </div>
</template>
<script>
import UserProfileCard from "src/components/UserProfileCard.vue";
import UserEditForm from "./UserEditForm.vue";

export default {
    name: "UserDetail",
    components: {
        UserEditForm,
        UserProfileCard,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        customers: {
            type: Array,
            required: true,
        },
        designers: {
            type: Array,
            required: true,
        },
        userRoles: {
            type: Array,
            required: true,
        },
        passwordMinLength: {
            type: Number,
            required: true,
        },
        userAdded: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
